import { TABLE_EVENT_TYPE } from "../../../core/TABLE_EVENT_TYPE";

import { IconFuncTypeEnum } from "../../../ts-types";

import { drillClick } from "../../drill";

export function bindIconClickEvent(table) {
    table.on(TABLE_EVENT_TYPE.ICON_CLICK, (iconInfo => {
        var _a;
        const {col: col, row: row, x: x, y: y, funcType: funcType, icon: icon, event: event} = iconInfo, {stateManager: stateManager} = table;
        if (funcType === IconFuncTypeEnum.dropDown) stateManager.triggerDropDownMenu(col, row, x, y, event); else if (funcType === IconFuncTypeEnum.sort) stateManager.triggerSort(col, row, icon, event); else if (funcType === IconFuncTypeEnum.frozen) stateManager.triggerFreeze(col, row, icon); else if (funcType === IconFuncTypeEnum.drillDown) drillClick(table); else if (funcType === IconFuncTypeEnum.collapse || funcType === IconFuncTypeEnum.expand) {
            const isHasSelected = !!(null === (_a = stateManager.select.ranges) || void 0 === _a ? void 0 : _a.length);
            stateManager.updateSelectPos(-1, -1), stateManager.endSelectCells(!0, isHasSelected), 
            table.toggleHierarchyState(col, row);
        }
    }));
}
//# sourceMappingURL=icon.js.map
